import React from 'react';
import { Navigate } from 'react-router-dom';

import { AppContainer } from '@/components/ui';
import { SectionCard } from '@/components/ds';
import AiAdmin from '@/screens/administration/components/ai/ai-admin';
import { getToken } from '@/lib/common';
import { hasUserAccessTo } from '@/lib/permissions';
import { PermissionArea } from '@cloudcost/shared-types/users';

function Ai() {
  if (!getToken()) {
    return <Navigate to="/" replace />;
  }

  if (!hasUserAccessTo(PermissionArea.ADMIN_PANEL)) {
    return <Navigate to="/" replace />;
  }

  return (
    <AppContainer>
      <SectionCard
        icon="spark"
        iconTone="ai"
        title="AI administration"
        subtitle="Optimization engine, Teams bot and integration checks">
        <AiAdmin />
      </SectionCard>
    </AppContainer>
  );
}

export default Ai;
